
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Reicht eine Befragung oder eine eigene Beobachtung nicht aus, um die Gründe für eine Schlafstörung zu ermitteln, so kann ein Aufenthalt im Schlaflabor Klarheit schaffen. Mit den Daten, die in der Nacht erfasst werden, befasst sich Esther Werth. Die Somnologin leitet das klinische Schlaflabor der neurologischen Klinik am Universitätsspital Zürich. Viele Leute leiden unter Schlafstörungen. Und es werden tendenziell mehr – das ist ein persönlicher Eindruck, den Esther Werth bestätigt.`}<br /><br />{`
Wird der Schlaf zum Problem, kann eine Nacht im Schlaflabor helfen: Das sind zwei karge Räume, getrennt durch den Überwachungsraum. Mit Ausnahme der zwei Glubschaugen, der Kameras an der Decke, und dem Infrarotstrahler in der Ecke unterscheiden sie sich kaum von einem normalen Spitalzimmer. Die Räume lassen sich komplett abdunkeln, sind schallisoliert und klimatisiert. Keine äusseren Faktoren sollen den Schlaf stören. Die Patientinnen und Patienten werden verdrahtet. Ihre Hirnströme werden ebenso registriert wie ihre Augenbewegungen, die Muskelanspannung, die Atmung oder der Sauerstoffgehalt im Blut.`}<br /><br />{`
Anhand der Daten macht sich Esther Werth auf die Suche nach dem «kleinsten Fehler im Orchester», der die Harmonie stört. Sie scrollt sich durch die erfassten Werte, durch die Schlafphasen, und sucht Antworten auf die Fragen: Wie ist der Schlaf gestört? Wo ist er gestört? Was ist die Ursache? Wie relevant ist die Störung? Manchmal ist es verblüffend: `}<M mdxType="M">{`Im Schlaflabor schlafen die Leute besser als zu Hause, trotz all der Kabel`}</M>{` – das zeigen neben den erfassten Daten auch die persönlichen Gespräche nach dem Aufwachen. Eine mögliche, überraschende Ursache: Der Schlaf nimmt im Alltag zu viel Platz ein. Dann entsteht Stress, «weil man eben unbedingt und unbedingt gut schlafen muss».`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;